<template>
  <div class="warehouseBill">
    <van-form label-width="120px">
      <van-field
        v-model="form.ManifestNumber"
        label="MANIFEST NO"
        label-class="number-label"
        :placeholder="$t.meta.input"
        :disabled="PAId ? true : false"
      >
        <template #button>
          <van-button
            size="small"
            type="info"
            @click="loadWarehousingWorkSheetByPreAlertInfo"
            :disabled="PAId ? true : false"
            >{{ $t.meta.confirm }}</van-button
          >
        </template>
      </van-field>

      <van-field
        v-model="form.Customer.text"
        :label="$t.warehouse.entrustEnterprise"
        :placeholder="$t.meta.input"
        @click="onShowEmit('showWarehouseBillCustomer')"
        clickable
        readonly
      />

      <van-field
        v-model="form.Customer.CustomerNumber"
        :label="$t.warehouse.customerNumber"
        readonly
        v-if="form.Customer.CustomerNumber"
      />

      <van-field
        v-model="form.ProductsName"
        :label="$t.warehouse.productsName"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.Warehouse.text"
        :label="$t.warehouse.warehouseSn"
        :placeholder="$t.meta.input"
        @click="onShowEmit('showWarehouseBillWarehouse')"
        clickable
        readonly
      />

      <van-field
        v-model="form.WarehouseNumber"
        :label="$t.warehouse.warehouseNumber"
        :placeholder="$t.meta.input"
      />

      <div class="custom-date">
        <div class="date-btn1">{{ $t.warehouse.warehousingTime }}</div>
        <div class="date-btn2" @click="showTimeDate('AST')">
          <span v-if="form.AppointmentStorageTime" class="value">{{
            form.AppointmentStorageTime
          }}</span>
          <span v-else class="placeholder">{{ $t.meta.select }}</span>
        </div>
      </div>

      <van-field
        v-model="form.GoodBatchReferenceNumber"
        :label="$t.warehouse.batchRefNumber"
        :placeholder="$t.meta.input"
      />

      <span v-if="form.ManifestNumber">
        <div class="title">{{ $t.warehouse.warehousingInfo }}</div>

        <van-field
          v-model="form.ActualDeliveryQuantity"
          :label="$t.warehouse.adQuantity"
          :placeholder="$t.meta.input"
        />

        <van-field
          v-model="form.NumberUnit"
          :label="$t.warehouse.piecesUnit"
          :placeholder="$t.meta.input"
        />

        <van-field
          v-model="form.IncomingVolume"
          :label="$t.warehouse.incomingVolume"
          :placeholder="$t.meta.input"
        />

        <van-field
          v-model="form.IncomingWeight"
          :label="$t.warehouse.incomingWeight"
          :placeholder="$t.meta.input"
        />

        <div class="custom-date">
          <div class="date-btn1">{{ $t.warehouse.ata }}</div>
          <div class="date-btn2" @click="showTimeDate('ATA')">
            <span v-if="form.ActualTimeArrival" class="value">{{
              form.ActualTimeArrival
            }}</span>
            <span v-else class="placeholder">{{ $t.meta.select }}</span>
          </div>
        </div>
      </span>

      <div class="title">{{ $t.warehouse.driverInfo }}</div>

      <van-field
        v-model="form.ContactPerson"
        :label="$t.warehouse.driverName"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.ContactPhone"
        :label="$t.warehouse.driverPhone"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.DeliveryLicensePlateNumber"
        :label="$t.warehouse.driverPlate"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.ExpressCompanyName"
        :label="$t.warehouse.expressCompany"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.ExpressNumber"
        :label="$t.warehouse.expressNumber"
        :placeholder="$t.meta.input"
      />

      <div class="multi-table" v-if="productList">
        <div class="add-title">{{ $t.warehouse.addProduct }}</div>
        <van-field name="stepper">
          <template #input>
            <van-stepper
              :min="0"
              :value="productList.length"
              @minus="handleProductDel"
              @plus="handleProductAdd"
              :disable-input="true"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in productList" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title">
              {{ $t.warehouse.cargoName }} {{ index + 1 }}
            </div>
            <div
              class="multi-table-btn"
              @click="handleProductDelByIndex(index)"
            >
              <van-icon name="close" />
            </div>
          </div>
          <van-field
            v-model="item.ProductName"
            :label="$t.warehouse.productsNameSn"
            :placeholder="$t.meta.input"
            @change="getProductList"
            required
          />
          <van-field
            v-model="item.UnitPrice"
            :label="$t.warehouse.unitPrice"
            :placeholder="$t.meta.input"
          />
          <div class="product-radio">
            <div class="product-radio-label">{{ $t.meta.currency }}</div>
            <van-radio-group
              v-model="item.Currency"
              direction="horizontal"
              class="product-radio-group"
            >
              <van-radio
                :name="currency.SCId"
                v-for="(currency, index) in currencyList"
                :key="index"
                >{{ currency.CurrencySn }}</van-radio
              >
            </van-radio-group>
          </div>
          <van-field
            v-model="item.TotalQuantity"
            :label="$t.warehouse.quantity"
            :placeholder="$t.meta.input"
            @change="getTotalQuantity(item.TotalQuantity, index)"
          />
          <van-field
            v-model="item.RemainQuantity"
            :label="$t.warehouse.surplus"
            readonly
          />
          <van-field
            v-model="item.Brand"
            :label="$t.warehouse.brand"
            :placeholder="$t.meta.input"
          />
          <van-field
            v-model="item.Model"
            :label="$t.warehouse.model"
            :placeholder="$t.meta.input"
          />
          <van-field
            v-model="item.Remark"
            :label="$t.warehouse.remark"
            :placeholder="$t.meta.input"
          />
          <van-field :label="$t.warehouse.productImage">
            <template #input>
              <van-button
                @click="imagePreview(imgUrlFilter(item.ProductPictures))"
                type="primary"
                size="small"
                style="vertical-align: top; margin: 10px 30px 10px 0px"
                v-if="item.ProductPictures"
                >{{ $t.meta.view }}</van-button
              >
              <van-uploader
                :after-read="afterRead1"
                @click-upload="uploaderClick(index)"
              >
                <van-image
                  :src="
                    item.ProductPictures && imgUrlFilter(item.ProductPictures)
                  "
                  width="50"
                  height="50"
                  fit="contain"
                  style="vertical-align: top"
                  v-if="item.ProductPictures"
                ></van-image>
                <van-button
                  type="info"
                  size="small"
                  style="vertical-align: top; margin: 10px 30px 10px 0px"
                  v-else
                  >{{ $t.meta.upload }}</van-button
                >
              </van-uploader>
            </template>
          </van-field>
        </div>
      </div>

      <div class="multi-table" v-if="form.PackingList">
        <div class="pack-title">{{ $t.warehouse.packingDetail }}</div>
        <van-field name="stepper">
          <template #input>
            <van-stepper
              :min="0"
              :value="form.PackingList.length"
              @minus="handleDelPack"
              @plus="handleAddPack"
              :disable-input="true"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in form.PackingList" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title">
              {{ $t.warehouse.caseNumberSn }} {{ index + 1 }}
            </div>
            <div class="multi-table-btn" @click="handleDelPackByIndex(index)">
              <van-icon name="close" />
            </div>
          </div>
          <van-field
            v-model="item.ParentPackName"
            :label="$t.warehouse.parentBox"
            @click="pickerShow(index, 'showParentPicker')"
            :placeholder="$t.meta.select"
            clickable
            readonly
          />
          <van-field
            v-model="item.BoxName"
            :label="$t.warehouse.caseNumber"
            :placeholder="$t.meta.input"
            required
          />
          <van-field
            v-model="item.Weight"
            :label="$t.warehouse.weight + ' ( KG )'"
            :placeholder="$t.meta.input"
            required
          />
          <van-field
            v-model="item.Long"
            :label="$t.warehouse.long + ' / cm'"
            :placeholder="$t.meta.input"
            required
          />
          <van-field
            v-model="item.Wide"
            :label="$t.warehouse.width + ' / cm'"
            :placeholder="$t.meta.input"
            required
          />
          <van-field
            v-model="item.Height"
            :label="$t.warehouse.height + ' / cm'"
            :placeholder="$t.meta.input"
            required
          />
          <van-field
            v-model="item.Remark"
            :label="$t.warehouse.remark"
            :placeholder="$t.meta.input"
          />

          <div class="multi-table-header">
            <div class="multi-table-title">{{ $t.warehouse.operation }}</div>
            <div class="multi-table-btn">
              <van-button
                type="danger"
                size="small"
                style="vertical-align: top"
                @click="handlePackageProductPush(index, item.ProductValue)"
                >{{ $t.warehouse.pushButton }}</van-button
              >
            </div>
          </div>

          <van-field
            v-model="item.ProductName"
            :label="$t.warehouse.productsNameSn"
            @click="pickerShow(index, 'showProductPicker')"
            :placeholder="$t.meta.select"
            clickable
            readonly
            required
          />

          <van-field
            v-model="item.PackingQuantity"
            :label="$t.warehouse.packingQty"
            :placeholder="$t.meta.input"
          />

          <template
            v-if="
              item.PackingListProducts && item.PackingListProducts.length > 0
            "
          >
            <div class="multi-table-header">
              <div class="multi-table-title">{{ $t.warehouse.cargoTitle }}</div>
            </div>

            <div class="packing-products">
              <div
                class="packing-products-item"
                v-for="(tag, tagIdx) in item.PackingListProducts"
                :key="tagIdx"
              >
                <span
                  >{{ tag.ProductName }} ( {{ $t.warehouse.packingQty }}
                  {{ tag.PackingQuantity }} )</span
                >
                <van-icon
                  name="cross"
                  v-if="!tag.PId"
                  @click="
                    handlePackageProductDel(
                      index,
                      tag.ProductId,
                      tag.PackingQuantity
                    )
                  "
                />
              </div>
            </div>
          </template>
        </div>
      </div>

      <div class="multi-table" v-if="groups && groups.length > 0">
        <div class="title">{{ $t.warehouse.goodsDetail }}</div>
        <div v-for="(group, index) in groups" :key="index">
          <van-field
            :value="index + 1"
            :label="$t.warehouse.caseNumberSn"
            readonly
          />
          <van-field
            :value="group.totalQuantity"
            :label="$t.warehouse.quantity"
            readonly
          />
          <van-field
            :value="group.totalPrice"
            :label="$t.warehouse.goodsValueTotal"
            readonly
          />
          <div v-for="(item, idx) in group.items" :key="idx">
            <van-field
              :value="idx + 1"
              :label="$t.warehouse.cargoName"
              readonly
            />
            <van-field
              v-model="item.ProductName"
              :label="$t.warehouse.productsNameSn"
              readonly
            />
            <van-field
              v-model="item.UnitPrice"
              :label="$t.warehouse.unitPrice"
              readonly
            />
            <div class="product-radio">
              <div class="product-radio-label">{{ $t.meta.currency }}</div>
              <van-radio-group
                v-model="item.Currency"
                direction="horizontal"
                class="product-radio-group"
                disabled
              >
                <van-radio
                  :name="currency.SCId"
                  v-for="(currency, index) in currencyList"
                  :key="index"
                  >{{ currency.CurrencySn }}</van-radio
                >
              </van-radio-group>
            </div>
            <van-field
              v-model="item.PackingQuantity"
              :label="$t.warehouse.packingQty"
              readonly
            />
            <van-field
              v-model="item.Brand"
              :label="$t.warehouse.brand"
              readonly
            />
            <van-field
              v-model="item.Model"
              :label="$t.warehouse.model"
              readonly
            />
            <van-field
              v-model="item.Remark"
              :label="$t.warehouse.remark"
              readonly
            />
            <van-field :label="$t.warehouse.productImage">
              <template #input>
                <van-image
                  width="80"
                  height="80"
                  fit="cover"
                  :src="imgUrlFilter(item.ProductPictures)"
                  @click="imagePreview(imgUrlFilter(item.ProductPictures))"
                  v-if="item.ProductPictures"
                />
                <span v-else>{{ $t.warehouse.noImage }}</span>
              </template>
            </van-field>
          </div>
        </div>
      </div>

      <div style="margin: 16px">
        <van-button round block type="info" @click="onSubmit">{{
          $t.meta.save
        }}</van-button>
      </div>
    </van-form>

    <van-popup v-model="showTimePicker" position="bottom">
      <van-datetime-picker
        type="datetime"
        :title="dateTimeTitle"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event)"
        @cancel="showTimePicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <fetch-list
      event="showWarehouseBillCustomer"
      type="customerManagement"
      request="getCustomerInfoSearchList"
      @onSelect="onSelectCustomer"
    ></fetch-list>

    <warehouse-fetch-list
      event="showWarehouseBillWarehouse"
      @onSelect="onSelectWarehouse"
    ></warehouse-fetch-list>

    <van-popup v-model="showParentPicker" round position="bottom">
      <van-picker
        :title="$t.warehouse.parentBox"
        show-toolbar
        :columns="parentOptions"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="parentConfirm"
        @cancel="showParentPicker = false"
      />
    </van-popup>

    <van-popup v-model="showProductPicker" round position="bottom">
      <van-picker
        :title="$t.warehouse.productList"
        show-toolbar
        :columns="productOptions"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="productConfirm"
        @cancel="showProductPicker = false"
      />
    </van-popup>
  </div>
</template>
<script>
import Vue from "vue";
import FetchList from "@components/fetchList/FetchList.vue";
import WarehouseFetchList from "@components/warehouseFetchList/WarehouseFetchList.vue";
import {
  Form,
  Field,
  Button,
  Icon,
  Image,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  Popup,
  DatetimePicker,
  Switch,
  Uploader,
  Stepper,
  Picker,
} from "vant";

Vue.use(Form)
  .use(Field)
  .use(Button)
  .use(Icon)
  .use(Image)
  .use(Radio)
  .use(RadioGroup)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Popup)
  .use(DatetimePicker)
  .use(Switch)
  .use(Uploader)
  .use(Stepper)
  .use(Picker);

export default {
  name: "warehouseBill",
  components: {
    FetchList,
    WarehouseFetchList,
  },
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      PAId: "",
      WHAFId: "",
      form: {
        WGId: "",
        EOSId: "",
        Warehouse: { value: "", text: "" },
        Customer: { value: "", text: "" },
        ProductsName: "",
        ContactPerson: "",
        ContactPhone: "",
        DeliveryLicensePlateNumber: "",
        ExpressCompanyName: "",
        ExpressNumber: "",
        ManifestNumber: "",
        WarehouseNumber: "",
        AppointmentStorageTime: "",
        GoodBatchReferenceNumber: "",
        ProductList: [],
        PackingList: [],
        OrderId: 0,
      },
      currencyList: [],
      groups: [],
      //日期
      selectDate: new Date(),
      dateTimeType: "AST",
      dateTimeTitle: "",
      showTimePicker: false,
      currentDate: "",
      //装箱
      productId: 1,
      productList: [],
      packId: 1,
      //picker
      parentOptions: [],
      showParentPicker: false,
      productOptions: [],
      showProductPicker: false,
      itemIndex: 0,
      //上传
      filesIndex: 0,
    };
  },
  created() {
    const { WHAFId, PAId, ManifestNumber } = this.$route.query;
    if (PAId) {
      this.PAId = PAId;
      this.form.ManifestNumber = ManifestNumber;
      this.loadWarehousingWorkSheetByPreAlertInfo();
    }
    if (WHAFId) {
      this.WHAFId = WHAFId;
      this.getOptions().then((success) => {
        if (success) {
          this.getWarehousingApplyForDetail();
        }
      });
    } else {
      this.getOptions();
    }
  },
  methods: {
    loadWarehousingWorkSheetByPreAlertInfo() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        let param = {
          PAId: this.PAId,
          ManifestNumber: this.form.ManifestNumber,
        };
        this.$api.storage
          .loadWarehousingWorkSheetByPreAlertInfo(param)
          .then((res) => {
            this.applyData(res.data, true);
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(
              this.$commonEnv.actionType.showDialog,
              {
                msg: error.message,
              }
            );
          });
      });
    },
    handlePackageProductPush(index, prductValue) {
      if (!prductValue) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
          msg: this.$t.warehouse.dialog1,
        });
        return;
      }

      var isLoaded = false;
      var pIdx = this.productList.findIndex((o) => o.ProductId === prductValue);

      for (var product of this.form.PackingList[index].PackingListProducts) {
        if (product.ProductId === prductValue) {
          isLoaded = true;
          break;
        }
      }
      if (isLoaded) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
          msg: this.$t.warehouse.dialog2,
        });
        return;
      }

      if (
        !this.form.PackingList[index].PackingQuantity ||
        this.form.PackingList[index].PackingQuantity == 0
      ) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
          msg: this.$t.warehouse.dialog3,
        });
        return;
      }

      if (
        !this.productList[pIdx].RemainQuantity ||
        this.productList[pIdx].RemainQuantity == 0
      ) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
          msg: this.$t.warehouse.dialog4,
        });
        return;
      }

      // console.log("装箱数量： " + this.form.PackingList[index].PackingQuantity);
      // console.log("剩余数量： " + this.productList[pIdx].RemainQuantity);
      if (
        parseInt(this.form.PackingList[index].PackingQuantity) >
        parseInt(this.productList[pIdx].RemainQuantity)
      ) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
          msg: this.$t.warehouse.dialog5,
        });
        return;
      }

      this.productList[pIdx].PackingQuantity =
        this.form.PackingList[index].PackingQuantity;

      this.productList[pIdx].RemainQuantity =
        parseInt(this.productList[pIdx].RemainQuantity) -
        parseInt(this.form.PackingList[index].PackingQuantity);

      this.form.PackingList[index].PackingListProducts.unshift(
        this.$commonMethod.deepClone(this.productList[pIdx])
      );

      this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
        msg: this.$t.warehouse.dialog6,
      });

      this.form.PackingList[index].ProductValue = null;
      this.form.PackingList[index].ProductName = "";
      this.form.PackingList[index].PackingQuantity = 0;

      this.getProductList();
    },
    handlePackageProductDel(index, tagId, qty) {
      var packIdx = this.form.PackingList[index].PackingListProducts.findIndex(
        (o) => o.ProductId == tagId
      );
      var productIdx = this.productList.findIndex((o) => o.ProductId == tagId);

      this.productList[productIdx].RemainQuantity =
        parseInt(this.productList[productIdx].RemainQuantity) + parseInt(qty);

      this.form.PackingList[index].PackingListProducts.splice(packIdx, 1);

      this.getProductList();
    },
    getTotalQuantity(qty, index) {
      this.productList[index].RemainQuantity = parseInt(qty);
      this.getProductList();
    },
    getProductList() {
      var productList = [];
      for (const pack of this.form.PackingList) {
        for (const product of pack.PackingListProducts) {
          if (product.ProductName) {
            productList.push(product);
          }
        }
      }
      this.form.ProductList = productList;
      this.groups = this.groupByProducts(this.form.PackingList);
      console.log(this.groups);
    },
    groupByProducts(data) {
      let groupedData = data.reduce((acc, item) => {
        let group = acc.find((group) => group.id === item.PackId) || {
          id: item.PackId,
          items: [],
          totalQuantity: 0,
          totalPrice: 0,
        };
        group.items = item.PackingListProducts;
        group.totalQuantity = group.items.reduce((pre, cur) => {
          return (
            pre + (cur.PackingQuantity ? parseInt(cur.PackingQuantity) : 0)
          );
        }, 0);
        group.totalPrice = group.items.reduce((pre, cur) => {
          return pre + (cur.UnitPrice ? parseFloat(cur.UnitPrice) : 0);
        }, 0);
        if (!acc.includes(group)) {
          acc.push(group);
        }
        return acc;
      }, []);
      return groupedData;
    },
    handleDelPackByIndex(index) {
      if (this.form.PackingList.length > 0) {
        this.form.PackingList.splice(index, 1);
      }
      this.getProductList();
    },
    handleDelPack() {
      if (this.form.PackingList.length > 0) {
        this.form.PackingList.pop();
      }
      this.getProductList();
    },
    handleAddPack() {
      this.form.PackingList.unshift({
        PackId: this.packId,
        ParentPackId: null,
        ParentPackName: "",
        BoxName: "",
        Weight: "",
        Long: "",
        Wide: "",
        Height: "",
        Remark: "",
        IsShow: true,
        PackingListProducts: [],
        ProductValue: null,
        ProductName: "",
        PackingQuantity: 0,
      });
      this.packId = this.packId + 1;
      this.getProductList();
    },
    handleProductDelByIndex(index) {
      this.productList.splice(index, 1);
    },
    handleProductDel() {
      if (this.productList.length > 0) {
        this.productList.pop();
      }
    },
    handleProductAdd() {
      this.productList.unshift({
        ProductId: this.productId,
        ProductPictures: "",
        ProductName: "",
        UnitPrice: "",
        Currency: null,
        TotalQuantity: 0,
        RemainQuantity: 0,
        Brand: "",
        Model: "",
        Remark: "",
      });
      this.productId = this.productId + 1;
    },
    onSelectCustomer(item) {
      this.form.Customer.text = item.text;
      this.form.Customer.value = item.value;
      this.form.Customer.CustomerNumber = item.CustomerNumber;
      this.$forceUpdate();
    },
    onSelectWarehouse(item) {
      this.form.Warehouse.text = item.text;
      this.form.Warehouse.value = item.value;
      this.$forceUpdate();
    },
    parentConfirm(e) {
      if (!e) {
        return;
      }
      if (this.form.PackingList[this.itemIndex].PackId == e.value) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
          msg: this.$t.warehouse.dialog7,
        });
        return;
      }
      this.form.PackingList[this.itemIndex].ParentPackName = e.text;
      this.form.PackingList[this.itemIndex].ParentPackId = e.value;
      this.showParentPicker = false;
    },
    productConfirm(e) {
      if (!e) {
        return;
      }
      this.form.PackingList[this.itemIndex].ProductName = e.text;
      this.form.PackingList[this.itemIndex].ProductValue = e.value;
      this.showProductPicker = false;
    },
    showTimeDate(type) {
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.dateTimeType = type;
      if (type == "AST") {
        this.dateTimeTitle = this.$t.warehouse.warehousingTime;
      }
      if (type == "ATA") {
        this.dateTimeTitle = this.$t.warehouse.ata;
      }
      this.showTimePicker = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      if (type === "month") {
        return val + this.$t.meta.month;
      }
      if (type === "day") {
        return val + this.$t.meta.day;
      }
      return val;
    },
    dateChange(date) {
      var formatDate = (val) => {
        var value = new Date(val);
        var time = value.toLocaleDateString();
        var hour =
          value.getHours() < 10 ? "0" + value.getHours() : value.getHours();
        var minute =
          value.getMinutes() < 10
            ? "0" + value.getMinutes()
            : value.getMinutes();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date + " " + hour + ":" + minute;
      };
      if (this.dateTimeType == "AST") {
        this.form.AppointmentStorageTime = formatDate(date);
      }
      if (this.dateTimeType == "ATA") {
        this.form.ActualTimeArrival = formatDate(date);
      }
      this.showTimePicker = false;
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    getWarehousingApplyForDetail() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          WHAFId: this.WHAFId,
        };
        this.$api.storage
          .getWarehousingApplyForDetail(param)
          .then((res) => {
            this.applyData(res.data);
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(
              this.$commonEnv.actionType.showDialog,
              {
                msg: error.message,
              }
            );
            reject();
          });
      });
    },
    applyData(data, isPreAlert = false) {
      if (isPreAlert) {
        this.form.Customer = {
          text: data.CustomerName,
          value: data.CustomerId,
          CustomerNumber: data.CustomerNumber,
        };
        this.form.WarehouseNumber = data.WarehouseNumber;
        this.form.GoodBatchReferenceNumber = data.GoodBatchReferenceNumber;
        this.form.AppointmentStorageTime = data.AppointmentStorageTime;
        this.form.ProductsName = data.ProductsName;
        this.form.ActualDeliveryQuantity = data.ActualDeliveryQuantity;
        this.form.NumberUnit = data.NumberUnit;
        this.form.IncomingVolume = data.IncomingVolume;
        this.form.IncomingWeight = data.IncomingWeight;
      } else {
        this.form.WGId = data.WGId;
        this.form.EOSId = data.EOSId;
        this.form.Warehouse = {
          text: data.WarehouseName,
          value: data.WHId,
        };
        this.form.Customer = {
          text: data.CustomerName,
          value: data.CustomerId,
          CustomerNumber: data.CustomerNumber,
        };
        this.form.ProductsName = data.ProductsName;
        this.form.ContactPerson = data.ContactPerson;
        this.form.ContactPhone = data.ContactPhone;
        this.form.DeliveryLicensePlateNumber = data.DeliveryLicensePlateNumber;
        this.form.ExpressCompanyName = data.ExpressCompanyName;
        this.form.ExpressNumber = data.ExpressNumber;
        this.form.WarehouseNumber = data.WarehouseNumber;
        this.form.AppointmentStorageTime = data.AppointmentStorageTime;
        this.form.GoodBatchReferenceNumber = data.GoodBatchReferenceNumber;
        this.productList = data.ProductList;
        for (var list of this.productList) {
          list.ProductId = list.PId;
          list.TotalQuantity = list.TotalQuantity;
          list.RemainQuantity = 0;
        }
        this.form.ProductList = data.ProductList;
        for (const product of this.form.ProductList) {
          product.ProductId = product.PId;
          product.Currency = product.Currency.toString();
        }
        this.form.PackingList = data.PackingList;
        for (const pack of this.form.PackingList) {
          pack.PackId = pack.PLId;
          pack.ParentPackId = pack.ParentId ? pack.ParentId : null;
          pack.ParentPackName = pack.ParentBoxName ? pack.ParentBoxName : "";
          for (const packProduct of pack.PackingListProducts) {
            packProduct.ProductId = packProduct.PId;
            packProduct.PackId = packProduct.PLId;
            packProduct.Currency = packProduct.Currency.toString();
          }
        }
        this.getProductList();
      }
    },
    pickerShow(index, pickerName) {
      if (pickerName == "showParentPicker") {
        var result = [];
        this.form.PackingList.forEach((item) => {
          if (item.BoxName) {
            let data = {
              text: item.BoxName,
              value: item.PackId,
            };
            result.push(data);
          }
        });
        this.parentOptions = this.$commonMethod.deepClone(result);
      }
      if (pickerName == "showProductPicker") {
        var result = [];
        this.productList.forEach((item) => {
          if (item.ProductName) {
            let data = {
              text: item.ProductName,
              value: item.ProductId,
            };
            result.push(data);
          }
        });
        this.productOptions = this.$commonMethod.deepClone(result);
        if (this.productOptions.length == 0) {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.warehouse.addProductFirst,
            type: "danger",
          });
          return;
        }
      }
      this[pickerName] = true;
      this.itemIndex = index;
      this.$forceUpdate();
    },
    onShowEmit(emit) {
      this.$bus.$emit(emit, true);
    },
    onSubmit() {
      this.$commonMethod.showLoading();
      var param = {
        WHAFId: this.WHAFId,
        WGId: this.form.WGId,
        EOSId: this.form.EOSId,
        WHId: null, //仓库id
        CustomerId: null, //客户id
        ProductsName: this.form.ProductsName,
        ContactPerson: this.form.ContactPerson,
        ContactPhone: this.form.ContactPhone,
        DeliveryLicensePlateNumber: this.form.DeliveryLicensePlateNumber,
        ExpressCompanyName: this.form.ExpressCompanyName,
        ExpressNumber: this.form.ExpressNumber,
        WarehouseNumber: this.form.WarehouseNumber,
        AppointmentStorageTime: this.form.AppointmentStorageTime,
        GoodBatchReferenceNumber: this.form.GoodBatchReferenceNumber,
        ProductList: this.productList.reverse(),
        PackingList: this.form.PackingList.reverse(),
        ManifestNumber: this.form.ManifestNumber,
        ActualDeliveryQuantity: this.form.ActualDeliveryQuantity,
        NumberUnit: this.form.NumberUnit,
        IncomingVolume: this.form.IncomingVolume,
        IncomingWeight: this.form.IncomingWeight,
        ActualTimeArrival: this.form.ActualTimeArrival,
      };
      param.CUserId = this.UserId;
      param.WHId = this.form.Warehouse.value;
      param.CustomerId = this.form.Customer.value;
      var request = null;
      if (this.WHAFId) {
        request = this.$api.storage.editWarehousingWorkSheet(param);
      } else {
        request = this.$api.storage.addWarehousingWorkSheet(param);
      }
      request
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    getOptions() {
      return new Promise((resolve) => {
        Promise.all([this.getCurrencyList()]).then((success) => {
          if (success) resolve(true);
        });
      });
    },
    getCurrencyList() {
      return new Promise((resolve) => {
        this.$api.financialManagement
          .getSystemAvailableCurrencyList()
          .then((res) => {
            this.currencyList = res.data;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(
              this.$commonEnv.actionType.showDialog,
              {
                msg: error.message,
              }
            );
          });
      });
    },
    uploaderClick(index) {
      this.filesIndex = index;
    },
    afterRead1(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.productList[this.filesIndex].ProductPictures = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.warehouseBill {
  ::v-deep .number-label {
    line-height: 33px;
  }
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  ::v-deep .van-stepper {
    flex: 1;
    text-align: center;
  }
  .custom-date {
    background: #ffffff;
    padding: 12px 16px;
    border-bottom: 1px solid #ebedf0;
    .date-btn1 {
      width: 33%;
      display: inline-block;
      margin-right: 5%;
      font-size: 14px;
      color: #646566;
    }
    .date-btn2 {
      width: 62%;
      display: inline-block;
      font-size: 14px;
      .value {
        color: #323233;
      }
      .placeholder {
        color: #c3c3c3;
      }
    }
  }
  .multi-table {
    .add-title {
      font-weight: bold;
      font-size: 14px;
      padding: 10px;
      background: #e4f6f0;
      color: #20b2aa;
      border: 2px solid #20b2aa;
    }
    .pack-title {
      font-weight: bold;
      font-size: 14px;
      padding: 10px;
      background: #e8f4ff;
      color: #1e90ff;
      border: 2px solid #87ceeb;
    }
    .multi-table-header {
      padding: 10px 15px;
      .multi-table-title {
        font-size: 14px;
        color: #2c88c1;
        width: 70%;
        display: inline-block;
        vertical-align: middle;
      }
      .multi-table-btn {
        font-size: 20px;
        color: #000;
        width: 30%;
        display: inline-block;
        text-align: right;
        vertical-align: middle;
        ::v-deep .van-button__text {
          font-size: 14px !important;
        }
      }
    }
    .product-radio {
      color: #646566;
      padding: 12px 16px;
      font-size: 14px;
      border-bottom: 1px solid #ebedf0;
      ::v-deep .van-radio__icon--disabled.van-radio__icon--checked {
        i {
          color: #1890ff;
          font-weight: bold;
        }
      }
      ::v-deep .van-radio__label--disabled.van-radio__label {
        color: #323233 !important;
        -webkit-text-fill-color: #323233 !important;
      }
      ::v-deep .van-field--disabled {
        .van-field__label,
        .van-field__control {
          color: #323233 !important;
          -webkit-text-fill-color: #323233 !important;
        }
      }
      .product-radio-label {
        display: inline-block;
        vertical-align: middle;
        width: 120px;
      }
      .product-radio-group {
        display: inline-flex;
        vertical-align: middle;
      }
    }
  }
  .packing-products {
    color: #333;
    background: #fff;
    padding: 15px 20px;
    font-size: 14px;
    border-bottom: 1px solid #ebedf0;
    .packing-products-item {
      padding: 5px 10px;
      border-radius: 5px;
      background: #1890ff;
      color: #fff;
      display: inline-block;
      margin-right: 10px;
      margin-bottom: 10px;
      .van-icon {
        margin-left: 10px;
        vertical-align: middle;
      }
    }
  }
}
</style>
